export const DEFAULT_ATTRS: Attrs = {
	enabled: false,
	measurementId: '',
	apiSecret: '',
};

export type Attrs = {
	readonly enabled: boolean;
	readonly trackingMethod?: 'gtm' | 'gtag';
	readonly measurementId: string;
	readonly apiSecret: string;
};

export type SetAttrs = ( attrs: Partial< Attrs > ) => void;
